import ProviderDetails from "../ProviderDetails";
import PlanLists from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";

const DataPlan = () => {
  return (
    <div className="h-full  w-[full] md:px-8 lg:px-[56px]">
      <ExternalContainer>
        <div>
          <Header />
          <div className="flex flex-col bp:flex-row items-start gap-12">
            <ProviderDetails />
            <PlanLists productType="gift_cards" />
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default DataPlan;
